function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import GeometryFactory from '../../geom/GeometryFactory';
import Coordinate from '../../geom/Coordinate';
import ArrayList from '../../../../../java/util/ArrayList';
var OffsetSegmentString = /*#__PURE__*/function () {
  function OffsetSegmentString() {
    _classCallCheck(this, OffsetSegmentString);
    OffsetSegmentString.constructor_.apply(this, arguments);
  }
  return _createClass(OffsetSegmentString, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      var coord = this._ptList.toArray(OffsetSegmentString.COORDINATE_ARRAY_TYPE);
      return coord;
    }
  }, {
    key: "setPrecisionModel",
    value: function setPrecisionModel(precisionModel) {
      this._precisionModel = precisionModel;
    }
  }, {
    key: "addPt",
    value: function addPt(pt) {
      var bufPt = new Coordinate(pt);
      this._precisionModel.makePrecise(bufPt);
      if (this.isRedundant(bufPt)) return null;
      this._ptList.add(bufPt);
    }
  }, {
    key: "reverse",
    value: function reverse() {}
  }, {
    key: "addPts",
    value: function addPts(pt, isForward) {
      if (isForward) {
        for (var i = 0; i < pt.length; i++) {
          this.addPt(pt[i]);
        }
      } else {
        for (var _i = pt.length - 1; _i >= 0; _i--) {
          this.addPt(pt[_i]);
        }
      }
    }
  }, {
    key: "isRedundant",
    value: function isRedundant(pt) {
      if (this._ptList.size() < 1) return false;
      var lastPt = this._ptList.get(this._ptList.size() - 1);
      var ptDist = pt.distance(lastPt);
      if (ptDist < this._minimimVertexDistance) return true;
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      var fact = new GeometryFactory();
      var line = fact.createLineString(this.getCoordinates());
      return line.toString();
    }
  }, {
    key: "closeRing",
    value: function closeRing() {
      if (this._ptList.size() < 1) return null;
      var startPt = new Coordinate(this._ptList.get(0));
      var lastPt = this._ptList.get(this._ptList.size() - 1);
      var last2Pt = null;
      if (this._ptList.size() >= 2) last2Pt = this._ptList.get(this._ptList.size() - 2);
      if (startPt.equals(lastPt)) return null;
      this._ptList.add(startPt);
    }
  }, {
    key: "setMinimumVertexDistance",
    value: function setMinimumVertexDistance(minimimVertexDistance) {
      this._minimimVertexDistance = minimimVertexDistance;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return OffsetSegmentString;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { OffsetSegmentString as default };
OffsetSegmentString.constructor_ = function () {
  this._ptList = null;
  this._precisionModel = null;
  this._minimimVertexDistance = 0.0;
  this._ptList = new ArrayList();
};
OffsetSegmentString.COORDINATE_ARRAY_TYPE = new Array(0).fill(null);